export default __webpack_public_path__ + "static/media/turbo1.fe269104.png";